import { Box, Col } from '@opendoor/atoms/box';
import { Link } from '@opendoor/atoms/link';
import { Text } from '@opendoor/atoms/text';

export interface StateLink {
  name: string;
  slug: string;
  count: number;
}

interface StateLinkListProps {
  states: StateLink[];
}

export const StateLinkList: React.FC<StateLinkListProps> = ({ states }) => {
  if (!states.length) {
    return null;
  }

  return (
    <Col as="section" aria-label="States with homes for sale" className="flex-1 py-4">
      <Col className="gap-3 px-2">
        <Text as="h2" className="text-subheader-sm">
          States with homes for sale
        </Text>
        <Box className="grid gap-4 [grid-template-columns:repeat(auto-fill,minmax(calc(var(--spacing)*50),1fr))]">
          {states
            .filter((state) => state.count > 0)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((state) => (
              <Box key={state.slug}>
                <Link analyticsName="state-directory-link" href={`/homes/state/${state.slug}`}>
                  {state.name} ({state.count})
                </Link>
              </Box>
            ))}
        </Box>
      </Col>
    </Col>
  );
};
